import { Box, Grid, Stack } from '@mui/material';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { useReportError } from '@/hooks/useReportError';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { EntityDetailsCard } from '@/modules/entities/components/EntityDetailsCard';
import { EntityNotesPerDeath } from '@/modules/entities/components/EntityNotesPerDeath/EntityNotesPerDeath';
import { useEntityPageDefinition } from '@/modules/entities/details/EntityDetailOverviewPage';

export function EntityDetailPage() {
  const entityId = useRequiredParam('entityId');
  const householdId = useRequiredParam('householdId');
  const { entityPageDefinition, error, loading } =
    useEntityPageDefinition(entityId);

  useReportError('failed to load trust on TrustDetailsPage', error);

  const tabs = useMemo(() => {
    return entityPageDefinition.summary;
  }, [entityPageDefinition]);

  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item sm={4}>
          <Box sx={{ height: '100%' }}>{entityPageDefinition.AssetsCard}</Box>
        </Grid>
        <Grid item sm={8}>
          <EntityDetailsCard
            tabs={tabs}
            loading={loading}
            entityId={entityId}
            householdId={householdId}
          />
        </Grid>

        <Grid item sm={4}></Grid>
        <Grid item sm={8}>
          <EntityNotesPerDeath entityId={entityId} />
        </Grid>
      </Grid>
      <Outlet />
    </Stack>
  );
}
